import React from "react";
import { Chip } from "./Chip";

export const TextChip = React.forwardRef((props, ref) => {
    const { filterValue, title, } = props;
    const { icon = "alphabetical-variant", iconFamily = "material-community", } = props;
    let label= filterValue?.value ? `${title}: ${filterValue?.value}` : title;

    const chipProps = {
        ...props,
        icon, iconFamily,
    }
    return <Chip ref={ref} icon { ...chipProps } title={label} />
})